import {
  SET_NEW_VT_DASH,
  FETCH_VT_TEMPLATES_START,
  FETCH_VT_TEMPLATES_FULFILLED,
  FETCH_VT_TEMPLATES_REJECTED,
  FETCH_VT_DASH_DATA_START,
  FETCH_VT_DASH_DATA_FULFILLED,
  FETCH_VT_DASH_DATA_REJECTED,
  SET_IS_VT_DASH_DISPLAYED,
  SET_VT_DASH_VIEW,
  SET_IS_EXERCISE_FILTERS_SHOWING,
  SET_UNSAVED_VT_DASH_MODAL,
  SET_SAVE_VT_DASH_MODAL,
  CREATE_VT_TEMPLATE_START,
  CREATE_VT_TEMPLATE_FULFILLED,
  CREATE_VT_TEMPLATE_REJECTED,
  SET_ABOUT_VT_DASH_MODAL,
  FETCH_PUBLIC_VT_DASH_DATA_START,
  FETCH_PUBLIC_VT_DASH_DATA_FULFILLED,
  FETCH_PUBLIC_VT_DASH_DATA_REJECTED,
  SET_DUPLICATE_VT_DASH_MODAL,
  DUPLICATE_VT_TEMPLATE_START,
  DUPLICATE_VT_TEMPLATE_FULFILLED,
  DUPLICATE_VT_TEMPLATE_REJECTED,
  SET_EDIT_VT_DASH_MODAL,
  EDIT_VT_TEMPLATE_START,
  EDIT_VT_TEMPLATE_FULFILLED,
  EDIT_VT_TEMPLATE_REJECTED,
  SET_DELETE_VT_DASH_MODAL,
  DELETE_VT_TEMPLATE_START,
  DELETE_VT_TEMPLATE_FULFILLED,
  DELETE_VT_TEMPLATE_REJECTED,
  SET_SHARE_VT_DASH_MODAL,
  FETCH_SHARE_VT_DASH_LINK_START,
  FETCH_SHARE_VT_DASH_LINK_FULFILLED,
  FETCH_SHARE_VT_DASH_LINK_REJECTED,
  SET_OPTION_VT_DASH_MODAL,
  SET_ONBOARDING_MODAL,
  CLEAR_VT_DASH_MODALS,
} from './actionTypes';

const initialState = {
  aboutModalShowing: false,
  deleteModalShowing: false,
  duplicateModalShowing: false,
  editModalShowing: false,
  isDashDisplayed: false,
  isEditTemplateLoading: false,
  isExerciseFiltersShowing: false,
  isNewVTDash: false,
  isReadOnlyView: false,
  isSaveTemplateLoading: false,
  isShareDashLinkLoading: false,
  isVTDashDataLoading: false,
  onboardingModalShowing: false,
  optionModalShowing: false,
  saveModalShowing: false,
  shareModalShowing: false,
  templatesLoading: false,
  unsavedModalShowing: false,
  vtDashView: 'overview',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_NEW_VT_DASH:
      return {
        ...state,
        isNewVTDash: action.payload,
      };
    case FETCH_VT_TEMPLATES_START:
      return {
        ...state,
        templatesLoading: true,
      };
    case FETCH_VT_TEMPLATES_FULFILLED:
      return {
        ...state,
        templatesLoading: false,
      };
    case FETCH_VT_TEMPLATES_REJECTED:
      return {
        ...state,
        templatesLoading: false,
      };
    case FETCH_VT_DASH_DATA_START:
      return {
        ...state,
        isVTDashDataLoading: true,
      };
    case FETCH_VT_DASH_DATA_FULFILLED:
      return {
        ...state,
        isVTDashDataLoading: false,
      };
    case FETCH_VT_DASH_DATA_REJECTED:
      return {
        ...state,
        isVTDashDataLoading: false,
      };
    case SET_IS_VT_DASH_DISPLAYED: {
      return {
        ...state,
        isDashDisplayed: action.payload,
      };
    }
    case SET_VT_DASH_VIEW: {
      return {
        ...state,
        vtDashView: action.payload,
      };
    }
    case SET_IS_EXERCISE_FILTERS_SHOWING: {
      return {
        ...state,
        isExerciseFiltersShowing: action.payload,
      };
    }
    case SET_UNSAVED_VT_DASH_MODAL: {
      return {
        ...state,
        unsavedModalShowing: action.payload,
      };
    }
    case SET_SAVE_VT_DASH_MODAL: {
      return {
        ...state,
        saveModalShowing: action.payload,
      };
    }
    case CREATE_VT_TEMPLATE_START: {
      return {
        ...state,
        isSaveTemplateLoading: true,
      };
    }
    case CREATE_VT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        isSaveTemplateLoading: false,
      };
    }
    case CREATE_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        isSaveTemplateLoading: false,
      };
    }
    case SET_ABOUT_VT_DASH_MODAL: {
      return {
        ...state,
        aboutModalShowing: action.payload.bool,
      };
    }
    case FETCH_PUBLIC_VT_DASH_DATA_START: {
      return {
        ...state,
        isPublicVTDashDataLoading: true,
        isReadOnlyView: true,
      };
    }
    case FETCH_PUBLIC_VT_DASH_DATA_FULFILLED: {
      return {
        ...state,
        isPublicVTDashDataLoading: false,
      };
    }
    case FETCH_PUBLIC_VT_DASH_DATA_REJECTED: {
      return {
        ...state,
        isPublicVTDashDataLoading: false,
      };
    }
    case SET_DUPLICATE_VT_DASH_MODAL: {
      return {
        ...state,
        duplicateModalShowing: action.payload.bool,
      };
    }
    case DUPLICATE_VT_TEMPLATE_START: {
      return {
        ...state,
        isDuplicateTemplateLoading: true,
      };
    }
    case DUPLICATE_VT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        isDuplicateTemplateLoading: false,
      };
    }
    case DUPLICATE_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        isDuplicateTemplateLoading: false,
      };
    }
    case SET_EDIT_VT_DASH_MODAL: {
      return {
        ...state,
        editModalShowing: action.payload.bool,
      };
    }
    case EDIT_VT_TEMPLATE_START: {
      return {
        ...state,
        isEditTemplateLoading: true,
      };
    }
    case EDIT_VT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        isEditTemplateLoading: false,
      };
    }
    case EDIT_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        isEditTemplateLoading: false,
      };
    }
    case SET_DELETE_VT_DASH_MODAL: {
      return {
        ...state,
        deleteModalShowing: action.payload.bool,
      };
    }
    case DELETE_VT_TEMPLATE_START: {
      return {
        ...state,
        isDeleteTemplateLoading: true,
      };
    }
    case DELETE_VT_TEMPLATE_FULFILLED: {
      return {
        ...state,
        isDeleteTemplateLoading: false,
      };
    }
    case DELETE_VT_TEMPLATE_REJECTED: {
      return {
        ...state,
        isDeleteTemplateLoading: false,
      };
    }
    case SET_SHARE_VT_DASH_MODAL: {
      return {
        ...state,
        shareModalShowing: action.payload.bool,
      };
    }
    case FETCH_SHARE_VT_DASH_LINK_START: {
      return {
        ...state,
        isShareDashLinkLoading: true,
      };
    }
    case FETCH_SHARE_VT_DASH_LINK_FULFILLED: {
      return {
        ...state,
        isShareDashLinkLoading: false,
      };
    }
    case FETCH_SHARE_VT_DASH_LINK_REJECTED: {
      return {
        ...state,
        isShareDashLinkLoading: false,
      };
    }
    case SET_OPTION_VT_DASH_MODAL: {
      return {
        ...state,
        optionModalShowing: action.payload,
      };
    }
    case SET_ONBOARDING_MODAL: {
      return {
        ...state,
        onboardingModalShowing: action.payload,
      };
    }
    case CLEAR_VT_DASH_MODALS: {
      return {
        ...state,
        aboutModalShowing: false,
        deleteModalShowing: false,
        duplicateModalShowing: false,
        editModalShowing: false,
        onboardingModalShowing: false,
        optionModalShowing: false,
        saveModalShowing: false,
        shareModalShowing: false,
        unsavedModalShowing: false,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
